<template>
<div>
  <div style="margin-bottom:10px;">
    <el-button type="primary" @click="add()">下单</el-button>
    <el-button type="primary" @click="exportData()">导出</el-button>
  </div>
  <!-- <xtable :config="sendTable.config" :data="sendTable.data" @clickRowBtn="sendTableRowBtn" @clickMultiBtn="" ref="sendOrderTable"></xtable> -->
  
  <xcurd :topBtns="sendTable.topBtns" :dialogs="sendTable.dialogs" :table="sendTable.table" @clickRowBtn="sendTableRowBtn" @clickMultiBtn="" @clickTopBtn="" ref="sendOrderTable"></xcurd>

  <el-dialog :title="orderForm.type=='add'?'下单':'订单详情'" v-model="orderForm.visible" size="small" v-loading="loading">
    <el-form :model="orderForm.data" label-width="100px" label-position="left">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="客户地区">
            <el-cascader
              :options="areaData.list"
              v-model="areaData.value"
              :props="areaData.props"
              @active-item-change="areaItemChange"
              v-if="orderForm.type=='add'"
            ></el-cascader>
            <div v-if="orderForm.type!='add'">{{orderForm.data._area.fullname}}</div>
          </el-form-item>
          <el-form-item label="支付方式">
            <el-radio-group v-model="orderForm.data.pay_type">
              <el-radio-button :label="1">客户付款</el-radio-button>
              <el-radio-button :label="2">商家付款</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input v-model="orderForm.data.name"></el-input>
          </el-form-item>
          <el-form-item label="客户电话">
            <el-input v-model="orderForm.data.tel"></el-input>
          </el-form-item>
          <el-form-item label="客户详细地址">
            <el-input v-model="orderForm.data.address"></el-input>
          </el-form-item>
          <!-- <el-form-item label="客户要求时间">
            <el-input v-model="orderForm.data.time_require"></el-input>
          </el-form-item> -->
          <el-form-item label="订单详情">
            <el-input type="textarea" :rows="4" v-model="orderForm.data.content2"></el-input>
          </el-form-item>
          <el-form-item label="商家备注">
            <el-input type="textarea" :rows="4" v-model="orderForm.data.remark_seller"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <h2>服务项目</h2>
          <div class="servCart">
            <div class="servCartList">
              <div class="item" v-for="(item, index) in orderForm.data.servs">
                <div class="it">
                  <el-select
                    v-if="orderForm.type=='add'"
                    v-model="item._serv"
                    @change="updatePrice"
                    placeholder="请输入关键词或拼音简写">
                    <el-option v-for="it in sellerServ" :label="it.name" :value="it.id"></el-option>
                  </el-select>
                  <el-select
                    v-else
                    v-model="item._serv.name"
                    disabled
                    @change="updatePrice"
                    placeholder="请输入关键词或拼音简写">
                    <el-option v-for="it in sellerServ" :label="it.name" :value="it.id"></el-option>
                  </el-select>
                </div>
                <div class="it">
                  <el-input-number style="width:120px;" @input="updatePrice" v-model="item.count" :min="1" :step="1" :disabled="orderForm.type != 'add'"></el-input-number>
                </div>
                <div class="opt" v-if="orderForm.data.servs.length != 1 && orderForm.type=='add'">
                  <el-button size="small" type="danger" icon="delete" @click="removeServCart(index)"></el-button>
                </div>
              </div>
            </div>
            <div class="opt-add" v-if="orderForm.type=='add'">
              <el-button size="small" icon="plus" @click="addServCart()">添加服务</el-button>
            </div>
          </div>
          <div class="servCartResult">
            <div class="item">
              <div class="tit">价格</div>
              <div class="val" v-if="orderForm.type!='add'">¥{{orderForm.data.price}}</div>
              <div class="val" v-if="orderForm.type=='add'">¥{{orderForm.price.seller}}</div>
            </div>
          </div>
          <div class="panel" style="margin-top:20px;">
            <div class="hd">订单详情</div>
            <div class="bd">
              <div class="detail" style="padding-bottom:20px;">
                <div class="item" v-if="tumbs.length > 0">
                  <div class="tit">图片</div>
                  <div class="field">
                    <img v-for="t in tumbs" :src="'http://www.888jigong.com/upload/wximg/'+t+'.jpg'" width="100%" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="orderForm.visible = false">取 消</el-button>
      <el-button type="primary" @click="addSubmit()" v-if="orderForm.type=='add'">下 单</el-button>
    </span>
  </el-dialog>

</div>
</template>
<script>
import ajax from 'xelement/ajax'
import Xtable from 'xelement/table'
import Xcurd from 'xelement/curd'
import Xform from 'xelement/form'
import XselectRemote from 'xelement/select_remote'
import { api, apiEnum, formatterList } from 'src/config'

let orderFormData = {
  _seller: null,
  price: 0,
  price_worker: 0,
  price_src: 0,
  price_worker_src: 0,
  name: '',
  tel: '',
  _area: null,
  address: '',
  time_require: '',
  pay_type: 1,
  content2: '',
  servs: [
    {
      _serv: null,
      count: 1
    }
  ]
}

export default {
  filters: {
    orderEvent: function (value) {
      var re = '';
      switch(value){
        case 'assign':
          re = '派单';
          break;
        case 'loop':
          re = '轮单';
          break;
        case 'receive':
          re = '接单';
          break;
        case 'refuse':
          re = '拒绝接单';
          break;
        case 'contact':
          re = '联系客户';
          break;
        case 'sign':
          re = '上门签到';
          break;
        case 'finish':
          re = '完成订单';
          break;
        case 'unfinish':
          re = '无法完成';
          break;
        case 'delay':
          re = '延时订单';
          break;
        case 'cancel':
          re = '取消订单';
          break;
      }
      return re;
    },
    dateTime: function (value) {
      return value.substring(5,16);
    }
  },
  data() {
    return {
      tumbs: [],
      loading: false,
      areaData: {
        value: [],
        list: [],
        props: {
          value: 'id',
          label: 'name',
          children: 'sub'
        }
      },
      sellerServ: [],
      queryApi: {
        seller: api.seller.query,
        area: api.area.query,
        serv: api.serv.query,
        subArea: api.area.getSub
      },
      orderForm: {
        visible: false,
        type: 'add',
        data: orderFormData,
        price: {
          seller: 0,
          worker: 0
        }
      },
      orderDetail: {
        data: {
          code: '',
          _seller: {},
          serv_code: '',
          pay_type: '',
          time_require: '',
          price: 0,
          price_total: 0,
          is_pay: 0,
          time_serv: 0,
          name: '',
          tel: '',
          _area: null,
          address: '',
          content2: '',
          remark: '',
          status: '',
          _admin: ''
        },
        timeline: []
      },
      sendTable: {
        topBtns: false,
        dialogs: [],
        table: {
          data: api.order.getList,
          config: {
            base: {
              showIndex: false
            },
            selection: false,
            expand: false,
            query: {
              data: {
                status: 'all',
                paytype: 'all',
                str: '',
                start: '',
                end: ''
              },
              form: [
                {
                  id: 'status',
                  type: 'radio',
                  data: [
                    {
                      id: 'all',
                      text: '全部'
                    },
                    {
                      id: 'undone',
                      text: '进行中'
                    },
                    {
                      id: 'finish',
                      text: '已完成'
                    },
                    {
                      id: 'cancel',
                      text: '已取消'
                    },
                    {
                      id: 'apply_cancel',
                      text: '申请取消'
                    }
                  ]
                },
                {
                  id: 'paytype',
                  type: 'radio',
                  data: [
                    {
                      id: 'all',
                      text: '全部'
                    },
                    {
                      id: apiEnum.payType.customer,
                      text: '客户付款'
                    },
                    {
                      id: apiEnum.payType.seller,
                      text: '商家付款'
                    }
                  ]
                },
                {
                  id: 'str',
                  type: 'input',
                  placeholder: '请输入关键字'
                },
                {
                  id: 'start',
                  placeholder: '开始时间',
                  type: 'date',
                  config: {
                    type: 'date'
                  }
                },
                {
                  id: 'end',
                  placeholder: '结束时间',
                  type: 'date',
                  config: {
                    type: 'date'
                  }
                }
              ]
            },
            rowBtns: {
              config: {
                width: '240',
                isFixed: true
              },
              list: [
                {
                  id: 'edit',
                  icon: 'edit',
                  text: '查看详情'
                },
                {
                  id: 'cancel',
                  text: '申请取消订单',
                  show: {
                    field: 'apply_cancel',
                    val: 1,
                    type: 'uneq'
                  }
                }
              ]
            },
            page: true,
            field: [
              {
                id: 'code',
                text: '订单号',
                width: '160',
                isFixed: true
              },
              {
                id: 'price',
                text: '金额',
                width: '100'
              },
              {
                id: 'pay_type',
                text: '支付方式',
                width: '120',
                formatter: 'payType'
              },
              {
                id: 'tel',
                text: '客户电话',
                width: '140'
              },
              {
                id: 'address',
                text: '客户地址',
                width: '240',
                tooltip: true
              },
              {
                id: 'status',
                text: '订单状态',
                width: '120',
                formatter: 'orderState'
              },
              {
                id: 'time_creat',
                text: '下单时间',
                width: '180'
              }
            ]
          }
        }
      }
    }
  },
  created(){
    let _self = this;
    ajax(this, 'get', api.seller.getServList, {}, (res) => {
      _self.sellerServ = res.data;
    })
    ajax(this, 'get', api.area.getSub, {id: 0}, (res) => {
      let list = [];
      for(let i in res.data.list){
        let item = {
          id: res.data.list[i].id,
          name: res.data.list[i].name,
        }
        if(res.data.list[i].is_last == 0){
          item.sub = [];
        }
        list.push(item);
      }
      _self.areaData.list = list;
    })
  },
  methods: {
    exportData(){
      let query = {};
      let queryPage = {
        page: 1,
        pageSize: 1000
      };
      let querySort = {
        sortField: '',
        sortOrder: '',
        mode: 'export'
      };
      query = Object.assign(queryPage, querySort, this.$refs.sendOrderTable.$refs.curdTable.queryData);
      for(let i in this.sendTable.table.config.query.form){
        if(this.sendTable.table.config.query.form[i].type == 'date'){
          if(query[this.sendTable.table.config.query.form[i].id]){
            let t = new Date(query[this.sendTable.table.config.query.form[i].id]);
            query[this.sendTable.table.config.query.form[i].id] = t.Format("yyyy-MM-dd");
          }
        }
      }
      let queryStr = '?';
      for(let i in query){
        queryStr += '';
        queryStr += i + '=' + query[i] + '&';
      }
      queryStr = queryStr.substring(0, queryStr.length - 1);
      window.open(api.order.getList + queryStr);
    },
    areaItemChange(val){
      let _self = this;
      ajax(this, 'get', api.area.getSub, {id: val[val.length - 1]}, (res) => {
        let list = [];
        let re = res.data.list;
        for(let i in re){
          let item = {
            id: re[i].id,
            name: re[i].name,
          }
          if(re[i].is_last == 0){
            item.sub = [];
          }
          list.push(item);
        }
        let obj = _self.areaData.list;
        let targetObj = [];
        for(let n in val){
          if(n == 0){
            for(let i in obj){
              if(obj[i].id == val[n]){
                targetObj[0] = obj[i];
                break;
              }
            }
          }else{
            for(let i in targetObj[n - 1].sub){
              if(targetObj[n - 1].sub[i].id == val[n]){
                targetObj[n] = targetObj[n - 1].sub[i];
              }
            }
          }
        }
        targetObj[targetObj.length - 1].sub = list;
      })
    },
    addSubmit(){
      var _self = this;
      let submitData = JSON.parse(JSON.stringify(this.orderForm.data));
      if(submitData._seller == null || submitData._seller == 0 || submitData._seller == '0'){
        this.$message({
          type: 'warning',
          message: '请选择客户'
        });
        return false;
      }
      if(this.areaData.value.length == 0){
        this.$message({
          type: 'warning',
          message: '请选择客户所在区域'
        });
        return false;
      }
      if(submitData.address == null || submitData.address == ''){
        this.$message({
          type: 'warning',
          message: '请输入详细地址'
        });
        return false;
      }
      if(submitData.tel.length != 11){
        this.$message({
          type: 'warning',
          message: '请输入正确格式的客户电话'
        });
        return false;
      }
      if(submitData.servs.length == 1 && submitData.servs[0]._serv == null){
        this.$message({
          type: 'warning',
          message: '请添加服务项目'
        });
        return false;
      }
      if(submitData.price == 0 || submitData.price == '0'){
        this.$message({
          type: 'warning',
          message: '请输入订单总格'
        });
        return false;
      }
      if(submitData.price_worker == 0 || submitData.price_worker == '0'){
        this.$message({
          type: 'warning',
          message: '请输入给师傅价格'
        });
        return false;
      }
      let str_servs = '';
      for(let i in submitData.servs){
        str_servs += '' + submitData.servs[i]._serv
        str_servs += ':' + submitData.servs[i].count + ';';
      }
      submitData.servs = str_servs;
      submitData._area = this.areaData.value[this.areaData.value.length - 1];
      this.loading = true;
      ajax(this, 'post', api.order.add, submitData, (res) => {
        _self.$message({
          type: 'success',
          message: '下单成功!'
        });
        _self.orderForm.visible = false;
      }, () => {
        _self.loading = false;
      })
    },
    updatePrice(){
      let _self = this;
      ajax(this, 'post', api.order.getPrice, {
        area: this.areaData.value[this.areaData.value.length - 1],
        servs: this.orderForm.data.servs
      }, (res) => {
        _self.orderForm.price.seller = res.data.seller;
        _self.orderForm.price.worker = res.data.worker;
        _self.orderForm.data.price = res.data.seller;
        _self.orderForm.data.price_worker = res.data.worker;
      })
    },
    addServCart(){
      let servItem = {
        _serv: null,
        count: 1
      }
      this.orderForm.data.servs.push(servItem);
    },
    removeServCart(index){
      this.orderForm.data.servs.splice(index, 1);
      this.updatePrice();
    },
    sendTableRowBtn(btn, row){
      if(btn.id == 'edit'){
        this.orderForm.type = 'detail';
        this.orderForm.data = JSON.parse(JSON.stringify(row));
        this.getOrderDetail(row.id);
        this.orderForm.visible = true;
      }else if(btn.id == 'cancel'){
        // if(row.apply_cancel == '1'){
        //   this.$$message({
        //     type: 'warning',
        //     showClose: true,
        //     message: '已申请，不能重复操作!'
        //   })
        //   return false;
        // }
        let _self = this;
        this.$prompt('请输入申请取消订单原因', '申请取消订单', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          let sendData = {
            'order_id': row.id,
            'reason': value
          }
          ajax(_self, 'post', api.order.applyCancel, sendData, (res) => {
            _self.$message({
              type: 'success',
              showClose: true,
              message: '操作成功!'
            });
            _self.$refs.sendOrderTable.getData();
          })
        }).catch(() => {
                 
        });
      }
    },
    getOrderDetail: function(orderId){
      var _self = this;
      ajax(this, 'get', api.order.get, {id: orderId}, (res) => {
        _self.orderDetail.data = res.data.detail;
        if(_self.orderDetail.data.tumb && _self.orderDetail.data.tumb != ''){
          let arr = _self.orderDetail.data.tumb.split(',');
          if(arr[arr.length - 1] == ''){
            arr.pop();
          }
          _self.tumbs = arr;
        }else{
          _self.tumbs = [];
        }
        _self.orderDetail.timeline = res.data.timeline;
      })
    },
    add(){
      this.orderForm.type = 'add';
      this.orderForm.data = JSON.parse(JSON.stringify(orderFormData));
      this.orderForm.visible = true;
    },
    formSubmitSuccess(dialog){
      if(dialog == 'before'){
        this.beforeForm.dialog.visible = false;
      }
    }
  },
  components: {
    Xtable,
    Xcurd,
    Xform,
    XselectRemote
  }
}
</script>


// WEBPACK FOOTER //
// order.vue?2ee341da